import { type ZodTypeAny, z } from 'zod';

export function isTruthy<T>(value: T | null | undefined | false): value is T {
  return Boolean(value);
}

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function oneOrMany<T extends ZodTypeAny>(schema: T) {
  return z.union([schema, z.array(schema)]);
}

type EnumLike = Record<string, string | number>;

/**
 * A zod helper to create a nativeEnum with a default value which is optional.
 * That means:
 *  - the field is *not* required in the input schema, but has a default value when parsed.
 *  - while instantiating an instance of the _inferred_ interface, this field is optional
 *
 * Ultimately any instance of the inferred interface at runtime reflects the optional nature of the field but parses inputs with a prescribed default
 */
export function optionalEnum<T extends EnumLike>(nativeEnum: T, defaultValue: T[keyof T]) {
  return z
    .nativeEnum(nativeEnum)
    .optional()
    .default(defaultValue)
    .transform((arg): T[keyof T] | undefined => arg ?? defaultValue) as unknown as z.ZodOptional<
    z.ZodType<T[keyof T]>
  >;
}
